import React, { useState, useEffect, useRef } from 'react';

import AvapCloudLogo from '../../assets/img/landingPage/AVAP_Framework.svg';
import bg from '../../assets/img/landingPage/erroBg.png';
import gradientCorner from '../../assets/img/landingPage/gradient_collab.png';


const lerp = (start: number, end: number, factor: number): number => {

    if (Math.abs(end - start) < 0.1) {
        return end;
    }
    return start + (end - start) * factor;
};

const Error500: React.FC = () => {
    const handleGoBack = () => {

        window.history.back();
    };


    const [targetPos, setTargetPos] = useState({ x: 0, y: 0 });
    const [currentPos, setCurrentPos] = useState({ x: 0, y: 0 });
    const pageRef = useRef<HTMLDivElement>(null);
    const animationFrameId = useRef<number | null>(null);


    const smoothFactor = 0.08;

    useEffect(() => {

        const handleMouseMove = (event: MouseEvent) => {
            if (pageRef.current) {
                const rect = pageRef.current.getBoundingClientRect();
                setTargetPos({
                    x: event.clientX - rect.left,
                    y: event.clientY - rect.top
                });
            }
        };


        const animateGradient = () => {
            setCurrentPos(prevPos => ({
                x: lerp(prevPos.x, targetPos.x, smoothFactor),
                y: lerp(prevPos.y, targetPos.y, smoothFactor)
            }));
            animationFrameId.current = requestAnimationFrame(animateGradient);
        };


        if (pageRef.current) {
            const rect = pageRef.current.getBoundingClientRect();
            const initialX = rect.width / 2;
            const initialY = rect.height / 2;
            setTargetPos({ x: initialX, y: initialY });
            setCurrentPos({ x: initialX, y: initialY });
        }

        const currentRef = pageRef.current;
        if (currentRef) {
            currentRef.addEventListener('mousemove', handleMouseMove);
            animationFrameId.current = requestAnimationFrame(animateGradient);
        }


        return () => {
            if (currentRef) {
                currentRef.removeEventListener('mousemove', handleMouseMove);
            }
            if (animationFrameId.current) {
                cancelAnimationFrame(animationFrameId.current);
            }
        };
    }, []);

    return (
        <div ref={pageRef} className="fl-mainWrapper error-404-page" style={{ backgroundImage: `url(${bg})` }}>

            <img src={gradientCorner} alt="" className="gradient-corner bottom-left" />
            <img src={gradientCorner} alt="" className="gradient-corner top-right" />

            <div
                className="cursor-gradient"
                style={{
                    left: `${currentPos.x}px`,
                    top: `${currentPos.y}px`,
                }}
            />

            <div className="error-404-container">
                <div className="error-404-content">
                    <p className="error-404-label">Error</p>
                    <p className="error-404-title">500</p>
                    <h2 className="error-404-subtitle">Internal Server Error</h2>
                    <p className="error-404-text">
                        We're sorry, but something went wrong on our end. Please try again later, and if the issue persists, contact our support team.
                    </p>
                    <button onClick={handleGoBack} className="error-404-button">
                        Go Back
                    </button>
                </div>
                <div className="error-404-footer">
                    <img src={AvapCloudLogo} alt="AVAP Cloud Logo" className="error-404-logo" />
                </div>
            </div>
        </div>
    );
};

export default Error500;
